/**
 * detail.js
 * Gestiona la vista de detalle de una receta.
 * Muestra y oculta el panel con animación CSS.
 */

import { getRecetas, getFiltradas } from './state.js';
import { escaparHTML } from './utils.js';

const panel = document.getElementById('panel-detalle');

/**
 * Muestra el detalle de una receta por su ID.
 * @param {number} id
 */
export function mostrarDetalle(id) {
  const receta = getRecetas().find((r) => r.id === id);
  if (!receta) return;

  // ── Calcular siguiente receta dentro de las filtradas ─
  const filtradas = getFiltradas();
  const indiceActual = filtradas.findIndex((r) => r.id === id);
  const siguiente = filtradas[indiceActual + 1] ?? null;

  // ── Construir contenido ───────────────────────────────
  panel.innerHTML = `
    <div class="detalle-panel__header">
      <button
        class="detalle-panel__volver"
        id="btn-volver"
        aria-label="Volver a la lista de recetas"
      >← Volver</button>
      <h2 class="detalle-panel__titulo">${escaparHTML(receta.nombre)}</h2>
      ${
        siguiente
          ? `
        <button
          class="detalle-panel__siguiente"
          id="btn-siguiente"
          aria-label="Ver siguiente receta: ${escaparHTML(siguiente.nombre)}"
        >Siguiente →</button>
      `
          : '<span class="detalle-panel__siguiente-placeholder"></span>'
      }
    </div>

    <div class="detalle-panel__contenido">

      <span class="badge-categoria detalle-panel__badge">
        ${escaparHTML(receta.categoria)}
      </span>

      <section class="seccion" aria-labelledby="titulo-ingredientes">
        <h3 class="seccion__titulo" id="titulo-ingredientes">Ingredientes</h3>
        <div class="seccion__contenido">${escaparHTML(receta.ingredientes || 'No disponible')}</div>
      </section>

      <section class="seccion" aria-labelledby="titulo-preparacion">
        <h3 class="seccion__titulo" id="titulo-preparacion">Preparación</h3>
        <div class="seccion__contenido">
          ${escaparHTML(receta.preparacion || 'Preparación no disponible')}
        </div>
      </section>

    </div>
  `;

  // ── Mostrar panel ─────────────────────────────────────
  panel.classList.add('detalle-panel--visible');
  panel.setAttribute('aria-hidden', 'false');
  panel.scrollTop = 0;

  // ── Foco accesible ────────────────────────────────────
  document.getElementById('btn-volver').focus();

  // ── Eventos ───────────────────────────────────────────
  document.getElementById('btn-volver').addEventListener('click', ocultarDetalle, { once: true });

  if (siguiente) {
    document
      .getElementById('btn-siguiente')
      .addEventListener('click', () => mostrarDetalle(siguiente.id), { once: true });
  }

  // ── Cerrar con Escape ─────────────────────────────────
  panel.addEventListener('keydown', cerrarConEscape);
}

/**
 * Oculta el panel de detalle.
 */
export function ocultarDetalle() {
  panel.classList.remove('detalle-panel--visible');
  panel.setAttribute('aria-hidden', 'true');
  panel.removeEventListener('keydown', cerrarConEscape);
}

/**
 * Cierra el panel al pulsar Escape.
 * @param {KeyboardEvent} e
 */
function cerrarConEscape(e) {
  if (e.key === 'Escape') ocultarDetalle();
}
